// Generated by ReScript, PLEASE EDIT WITH CARE

import * as ResponseHandler$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/helper-modules/response-handler/ResponseHandler.bs.js";
import * as CrmControlledReleaseEntityMapper from "../entity-mapper/CrmControlledReleaseEntityMapper.bs.js";

var execute = CrmControlledReleaseEntityMapper.execute;

var BetaUserResponseConverterConfig = {
  execute: execute
};

var partial_arg = ResponseHandler$Catalyst.ResponseConverter;

var BetaUserResponseConverter = partial_arg(BetaUserResponseConverterConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

export {
  BetaUserResponseConverterConfig ,
  BetaUserResponseConverter ,
  
}
/* BetaUserResponseConverter Not a pure module */
